import { render } from "./TableZoomDropdown.vue?vue&type=template&id=c51b9bbc&scoped=true&ts=true"
import script from "./TableZoomDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableZoomDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./TableZoomDropdown.vue?vue&type=style&index=0&id=c51b9bbc&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51b9bbc"],['__file',"resources/js/core/report/components/TableZoomDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c51b9bbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c51b9bbc', __exports__)) {
    console.log('reload')
    api.reload('c51b9bbc', __exports__)
  }
  
  module.hot.accept("./TableZoomDropdown.vue?vue&type=template&id=c51b9bbc&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('c51b9bbc', render)
  })

}


export default __exports__